<template>
  <div>
    <page-main
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
      @batchDel="submitDel"
    >
      <page-header
        ref="header"
        slot="header"
        :disabled="disabled"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
        @batchDel="batchDel"
        @export="exportVisible = true"
      />
    </page-main>
    <EditFormDialog
      :orderCode="orderCode"
      :visible.sync="editFormDialogOptions.visible"
      :title="editFormDialogOptions.title"
      :orderBatchCode="editFormDialogOptions.orderBatchCode"
      :optType="editFormDialogOptions.optType"
      :orderType="orderType"
      :custCode="custCode"
      @reload="reload"
    />
    <ExportDialog :orderCode="orderCode" :visible.sync="exportVisible" />
  </div>
</template>

<script>
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import PageMain from './main.vue'
import PageHeader from './header.vue'
import EditFormDialog from '../edit-form/dialog.vue'
import ExportDialog from '../export-dialog'
export default {
  props: {
    orderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    orderType: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  components: { PageMain, PageHeader, EditFormDialog, ExportDialog },
  mixins: [BaseTable, EditLoading],
  data() {
    return {
      usePage: true,
      exportVisible: false,
      editFormDialogOptions: {
        visible: false,
        title: '',
        orderBatchCode: '',
        orderCode: '',
        optType: '',
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .orderBatchListApi({
          orderCode: this.orderCode,
          ...form,
          ...this.page,
          pageSize: 1000, //设置查询最大条数为1000
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, params = {} }) {
      const types = {
        edit:
          this.$l('dialog_title_order_batch_edit') || '编辑订单交货批次信息',
        add: this.$l('dialog_title_order_batch_add') || '添加订单交货批次信息',
        detail:
          this.$l('dialog_title_order_batch_detail') || '订单交货批次详情',
        copy:
          this.$l('dialog_title_order_batch_copy') || '复制订单交货批次信息',
      }
      this.editFormDialogOptions = {
        visible: true,
        optType: type,
        title: types[type],
        orderBatchCode: params.orderBatchCode,
      }
    },
    batchDel() {
      const listCode = this.$refs.main.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .orderBatchDelApi({ listCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.reload()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
